import React from "react";
import DropdownMenuItem from "../Dropdown/MenuItem";

const NavbarDropdownMenuItem = ({ children, ...props }) => {
	return <DropdownMenuItem {...props}>{children}</DropdownMenuItem>;
};

NavbarDropdownMenuItem.propTypes = {
	...DropdownMenuItem.propTypes,
};

const NavbarDropdownMenuItemLink = ({ className, ...props }) => {
	return <DropdownMenuItem.Link className={className} {...props} />;
};

NavbarDropdownMenuItemLink.propTypes = {
	...DropdownMenuItem.Link.propTypes,
};

NavbarDropdownMenuItem.Link = NavbarDropdownMenuItemLink;

export default NavbarDropdownMenuItem;
